import React from "react";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import LoaderUI from "../loader/loader";
import { useNavigate } from "react-router-dom";
import Header from "../../../features/manufacturerInterface/common/Header";
import Footer from "../../../features/manufacturerInterface/common/Footer";

const ManufacturerLayout = ({ children }) => {
    //Responsive menu toggle
    const [toggle, setToggle] = React.useState(false);

    const handleToggle = () => {
        setToggle(!toggle);
    };

    const navigate = useNavigate();
    let loginUser = useSelector(state => state.login?.user?.data?.user)
    if (loginUser.role !== "MANUFACTURER")
      navigate('/dashboard')

    let isLoading = useSelector(state => state.loader.isLoading);
    return (
        <main className={`${toggle ? 'toggled' : ''} main`}>
            <Header toggle={handleToggle} />
            <span className='overlay' onClick={handleToggle}></span>
            <ToastContainer />
            <div className="v-wrapper">
                <div className='container'>
                    {isLoading && <LoaderUI
                        loader={isLoading}
                        overlay={true}
                        overlayRadius='rounded-10'
                        FullWindow={true}
                        color="danger"
                        animation="border"
                        customSize="lg"
                    />}
                    {children}
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default ManufacturerLayout;
